import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./app/App";
import { bindPwaInstallBridge } from "./shared/pwa/pwaInstallBridge";
import { registerServiceWorker } from "./shared/pwa/registerServiceWorker";
import "./index.css";
import "./App.css";

// Capture install prompt before React mounts (critical on later reloads).
bindPwaInstallBridge();
registerServiceWorker();

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
